import { useEffect, useState } from "react";

import { useChartEntities } from "hooks/charts";

import { useDashboardDispatch } from "../../dashboard/hooks";

/**
 * Custom hook that tracks modifications to chart settings and updates dashboard state.
 *
 * This hook watches for changes in chart properties (chartType, product, features, locks)
 * and dispatches an action to indicate widget modification when changes are detected.
 *
 * @param {string} id - The unique identifier of the chart to track
 */
const useChartModificationTracker = (id: string) => {
  const { chartType, product, features, locks } = useChartEntities(id);
  const dashboardDispatch = useDashboardDispatch();
  const [lastSettings, setLastSettings] = useState<string>();

  useEffect(() => {
    const nextSettings = JSON.stringify({
      chartType,
      product,
      features,
      locks
    });

    if (!lastSettings) {
      setLastSettings(nextSettings);
    } else if (nextSettings !== lastSettings) {
      dashboardDispatch({ payload: { hasModifiedWidgets: true } });
      setLastSettings(nextSettings);
    }
  }, [chartType, product, features, locks, lastSettings, dashboardDispatch]);
};

export default useChartModificationTracker;
